<template>
  <VDialog :attach="true" v-model="showDialogRef" max-width="500">
    <VCard class="pa-4 magicLinkSuccessCard" v-if="successMessage">
      <VCardTitle class="cardTitle">
        <span>
          <VIcon icon="mdi-check-circle" color="success" />
          Check Your Email!
        </span>
      </VCardTitle>

      <VCardText>
        <VRow>
          <VCol class="py-0">We emailed a link to {{ email }}.</VCol>
        </VRow>

        <VRow>
          <VCol class="py-0">
            Click the link in your email to access your account.
          </VCol>
        </VRow>
      </VCardText>
    </VCard>

    <VCard class="pa-4 magicLinkRequestCard" v-else :loading="isLoading">
      <template v-slot:loader="{ isActive }">
        <VProgressLinear
          v-if="isLoading"
          :active="isActive"
          color="primary"
          height="4"
          indeterminate
        />
      </template>

      <VCardTitle class="px-4">
        <VRow>
          <VCol>
            <span>Get Instant Access!</span>
          </VCol>
        </VRow>
      </VCardTitle>

      <VCardText class="px-4 py-4">
        <VRow>
          <VCol class="py-0">
            Enter your email to receive a login link.
            <VIcon class="pr-2" color="#e5d634" icon="mdi-creation" />
          </VCol>
        </VRow>

        <VRow>
          <VCol class="pt-0 pb-2">
            (Only sent if an account exists with this email)
          </VCol>
        </VRow>

        <VRow v-if="errorMessage">
          <VCol>
            <VCard class="pa-2" color="error">{{ errorMessage }}</VCard>
          </VCol>
        </VRow>

        <VRow>
          <VCol>
            <VTextField
              v-model="email"
              label="Email"
              density="compact"
              variant="outlined"
              hide-details
              autocapitalize="off"
              :rules="[emailRules]"
            />
          </VCol>
        </VRow>
      </VCardText>

      <VCardActions class="px-4">
        <div class="d-flex flex-column w-100">
          <span class="py-1 w-100">
            <VBtn
              class="w-100 text-none"
              :disabled="isLoading || !emailIsValid"
              variant="flat"
              color="primary"
              @click="sendRequest"
            >
              Get Login Link
            </VBtn>
            <!-- <VBtn :disabled="isLoading" @click="sendRequest">Save</VBtn> -->
          </span>

          <span class="py-1 w-100">
            <VBtn
              class="w-100 text-none"
              :disabled="isLoading"
              variant="outlined"
              @click="close"
            >
              Go Back
            </VBtn>
            <!-- <VBtn :disabled="isLoading" @click="sendRequest">Save</VBtn> -->
          </span>
        </div>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup>
import { computed, ref, toRefs, watch } from 'vue';
import { requestMagicLink } from './api';

const props = defineProps({
  showDialog: { type: Boolean, required: true },
});

const emit = defineEmits({
  close: null,
});

const { showDialog } = toRefs(props);
const showDialogRef = ref(props.showDialog);
const isLoading = ref(false);
const email = ref('');

const successMessage = ref('');
const errorMessage = ref('');

watch(showDialog, (newValue) => {
  showDialogRef.value = newValue;
});
watch(showDialogRef, (newValue) => {
  if (!newValue) {
    close();
  }
});

const emailValidator = /\S+@\S+\.\S+/;

const emailIsValid = computed(() => {
  return emailValidator.test(email.value);
});

/** */
function emailRules() {
  if (!emailIsValid.value) {
    return 'Please Enter a Valid Email';
  }
  return true;
}

/** */
async function sendRequest() {
  try {
    isLoading.value = true;
    await requestMagicLink({
      username: email.value,
    });

    successMessage.value = 'Email Link Sent';
    setTimeout(() => {
      close();
    }, 10000);
  } catch (e) {
    console.error(e);
    errorMessage.value = 'Something Went Wrong';
  }

  isLoading.value = false;
}

/** */
function close() {
  isLoading.value = false;
  email.value = '';
  errorMessage.value = '';
  successMessage.value = '';

  emit('close');
}
</script>
